var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contato text-center"},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":_vm.btnLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.text))]),_c('br'),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }